import { createFileRoute, Link } from "@tanstack/react-router";
import { ArrowRight } from "lucide-react";

import { SiteLayout } from "@/components/SiteLayout";
import { GUIDES } from "@/lib/guides-content";

const TITLE = "Guias de viagem: pedágio, combustível e custo por km — TrajetoFácil";
const DESCRIPTION =
  "Guias práticos para planejar o custo da sua viagem: como calcular pedágio, estimar combustível por km/l, cobrança por eixos e precificação de frete.";
const URL = "https://www.trajetofacil.com.br/guias";

export const Route = createFileRoute("/guias/")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESCRIPTION },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESCRIPTION },
      { property: "og:type", content: "website" },
      { property: "og:url", content: URL },
      { name: "twitter:card", content: "summary" },
    ],
    links: [{ rel: "canonical", href: URL }],
  }),
  component: GuidesIndexPage,
});

function GuidesIndexPage() {
  return (
    <SiteLayout>
      <header className="max-w-2xl">
        <h1 className="text-3xl font-extrabold tracking-tight text-foreground">Guias de planejamento de viagem</h1>
        <p className="mt-3 text-base leading-7 text-muted-foreground">
          Conteúdo prático para calcular o custo real de viajar de carro, moto, ônibus ou caminhão —
          pedágio, combustível e precificação por quilômetro.
        </p>
      </header>

      <ul className="mt-10 space-y-4">
        {GUIDES.map((guide) => (
          <li key={guide.slug}>
            <Link
              to="/guias/$slug"
              params={{ slug: guide.slug }}
              className="group block rounded-2xl border border-border bg-card p-5 transition hover:border-primary/50 hover:shadow-sm"
            >
              <h2 className="text-lg font-bold text-foreground group-hover:text-primary">
                {guide.title}
              </h2>
              <p className="mt-2 text-sm leading-6 text-muted-foreground">{guide.description}</p>
              <span className="mt-3 inline-flex items-center gap-1 text-sm font-medium text-primary">
                Ler guia <ArrowRight className="size-4 transition-transform group-hover:translate-x-0.5" />
              </span>
            </Link>
          </li>
        ))}
      </ul>
    </SiteLayout>
  );
}
